<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="form.contains('nomStructure')" class="col-12 col-lg">
			<label for="nomStructure" class="form-label theme-main-color fw-bold"
				>Nom de la structure</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="nomStructure"
				name="nomStructure"
				formControlName="nomStructure"
				[ngClass]="{
					'is-invalid': nomStructure.invalid,
					'is-valid': nomStructure.dirty && nomStructure.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeEntreprise" class="form-label fw-bold"
				>Type de structure</label
			>
			<select
				id="typeEntreprise"
				class="form-select"
				name="typeEntreprise"
				formControlName="typeEntreprise"
				>
				<option *ngFor="let typeEntreprise of listTypeStructure" value="{{ typeEntreprise.id }}">
					{{ typeEntreprise?.name}}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('siret')"  class="col-12 col-lg-6">
			<label for="siret" class="form-label theme-main-color fw-bold"
				>SIRET</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="siret"
				name="siret"
				formControlName="siret"
			/>
		</div>
		<div *ngIf="form.contains('codeNaf')" class="col-12 col-lg-6">
			<label for="codeNaf" class="form-label theme-main-color fw-bold"
				>Code NAF</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="codeNaf"
				name="codeNaf"
				formControlName="codeNaf"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('addressStructure')" class="col-12 col-lg">
			<label for="addressStructure" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="addressStructure"
				name="addressStructure"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="addressStructure"
				(keyup)="selectedAddressKeyUp($event.target)"
				(typeaheadOnSelect)="onAddressSelect($event)"
			/>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Contact 1</span>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('firstNameContact1')" class="col-12 col-lg">
			<label for="firstNameContact1" class="form-label theme-main-color fw-bold"
				>Prénom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="firstNameContact1"
				name="firstNameContact1"
				formControlName="firstNameContact1"
				[ngClass]="{
					'is-invalid': firstNameContact1.invalid,
					'is-valid': firstNameContact1.dirty && firstNameContact1.valid
				}"
			/>
			<div
				*ngIf="firstNameContact1.invalid && (firstNameContact1.dirty || firstNameContact1.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="firstNameContact1.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstNameContact1.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastNameContact1')" class="col-12 col-lg">
			<label for="lastNameContact1" class="form-label theme-main-color fw-bold"
				>Nom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="lastNameContact1"
				name="lastNameContact1"
				formControlName="lastNameContact1"
				[ngClass]="{
					'is-invalid': lastNameContact1.invalid,
					'is-valid': lastNameContact1.dirty && lastNameContact1.valid
				}"
			/>
			<div
				*ngIf="lastNameContact1.invalid && (lastNameContact1.dirty || lastNameContact1.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="lastNameContact1.errors?.required">Un nom est requis</span>
				<span *ngIf="lastNameContact1.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('emailContact1')"  class="col-12 col-lg-6">
			<label for="emailContact1" class="form-label theme-main-color fw-bold"
				>Email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="emailContact1"
				name="emailContact1"
				formControlName="emailContact1"
			/>
		</div>
		<div *ngIf="form.contains('telephoneContact1')" class="col-12 col-lg-6">
			<label for="telephoneContact1" class="form-label theme-main-color fw-bold"
				>Téléphone</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="telephoneContact1"
				name="telephoneContact1"
				formControlName="telephoneContact1"
			/>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('fonctionContact1')"  class="col-12 col-lg-6">
			<label for="fonctionContact1" class="form-label theme-main-color fw-bold"
				>Fonction</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="fonctionContact1"
				name="fonctionContact1"
				formControlName="fonctionContact1"
			/>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Contact 2</span>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('firstNameContact2')" class="col-12 col-lg">
			<label for="firstNameContact2" class="form-label theme-main-color fw-bold"
				>Prénom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="firstNameContact2"
				name="firstNameContact2"
				formControlName="firstNameContact2"
				[ngClass]="{
					'is-invalid': firstNameContact2.invalid,
					'is-valid': firstNameContact2.dirty && firstNameContact2.valid
				}"
			/>
			<div
				*ngIf="firstNameContact2.invalid && (firstNameContact2.dirty || firstNameContact2.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="firstNameContact2.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstNameContact2.errors?.maxlength"
					>Le prénom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="firstNameContact2.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastNameContact2')" class="col-12 col-lg">
			<label for="lastNameContact2" class="form-label theme-main-color fw-bold"
				>Nom</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="lastNameContact2"
				name="lastNameContact2"
				formControlName="lastNameContact2"
				[ngClass]="{
					'is-invalid': lastNameContact2.invalid,
					'is-valid': lastNameContact2.dirty && lastNameContact2.valid
				}"
			/>
			<div
				*ngIf="lastNameContact2.invalid && (lastNameContact2.dirty || lastNameContact2.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="lastNameContact2.errors?.required">Un nom est requis</span>
				<span *ngIf="lastNameContact2.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="lastNameContact2.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('emailContact2')"  class="col-12 col-lg-6">
			<label for="emailContact2" class="form-label theme-main-color fw-bold"
				>Email</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="emailContact2"
				name="emailContact2"
				formControlName="emailContact2"
			/>
		</div>
		<div *ngIf="form.contains('telephoneContact2')" class="col-12 col-lg-6">
			<label for="telephoneContact1" class="form-label theme-main-color fw-bold"
				>Téléphone</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="telephoneContact2"
				name="telephoneContact2"
				formControlName="telephoneContact2"
			/>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('fonctionContact2')"  class="col-12 col-lg-6">
			<label for="fonctionContact2" class="form-label theme-main-color fw-bold"
				>Fonction</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="fonctionContact2"
				name="fonctionContact2"
				formControlName="fonctionContact2"
			/>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					!(isAddressDefault.value || isAddressSelected.value) ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
